export const Bar = ({ animationDuration, progress }) => {
  return (
    <div
      className="bg-blue-hedgehog h-1 w-full left-0 top-0 fixed rounded-r-lg"
      style={{ marginLeft: `${(-1 + progress) * 100}%`, transition: `margin-left ${animationDuration}ms linear`, zIndex: 9000 }}
    ></div>
  );
};
